import { render } from "./Birthdate.vue?vue&type=template&id=602105f0"
import script from "./Birthdate.vue?vue&type=script&lang=js"
export * from "./Birthdate.vue?vue&type=script&lang=js"

import "./Birthdate.vue?vue&type=style&index=0&id=602105f0&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__